import React from 'react';

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <ul className="greenbullet-list sept">
                                                <li>Ask someone whose opinion you’d value to watch your video
                                                    and rate you using the table below.
                                                </li>
                                            </ul>
                                            <p>If you don’t want to film yourself, ask someone else to be your
                                                ‘audience’ and rate your performance
                                                using the table (following the steps above).</p>
                                            <div className="border_subtitle">Key:</div>
                                            <p className="agree-text"><span
                                                className="brown boldtext contentSpaceRight">1.</span> Very
                                                ineffective&nbsp;&nbsp;    <span
                                                    className="brown boldtext contentSpaceRight">2.</span> Ineffective &nbsp;&nbsp;
                                                <span
                                                    className="brown boldtext contentSpaceRight">3.</span> Effective &nbsp;&nbsp;
                                                <span
                                                    className="brown boldtext contentSpaceRight">4.</span> Very
                                                effective</p>
                                            <div className="mobile-scroll">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport ilead_v_sport_new_task tablesrink">
                                                    <tbody>
                                                    <tr>
                                                        <th width="50%" align="left" valign="top" colSpan="2"
                                                            className="green_curve green_curve1">Video Ratings
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th width="80%" align="left" valign="top"
                                                            style={{borderTopLeftRadius:'0px'}}>Behaviour
                                                        </th>
                                                        <th width="20%" align="left" valign="top"
                                                            style={{borderTopRightRadius:'0px'}}>Rating 1-4
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="lightgreen"><p>Is the message / story
                                                            clear?</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">
                                                            <p className="ilead-slect-box-yellow">

                                                                <select className="custom-dropdown"
                                                                        name="IsTheMessageStoryClear"
                                                                        value={pageData?.VideoRatings?.IsTheMessageStoryClear}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="darkgreen"><p>Is it suited to the
                                                            audience?</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="IsItSuitedToTheAudience"
                                                                        value={pageData?.VideoRatings?.IsItSuitedToTheAudience}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="lightgreen"><p>Did you build rapport?</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DidYouBuildRapport"
                                                                        value={pageData?.VideoRatings?.DidYouBuildRapport}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="darkgreen"><p>Do you come across with
                                                            credibility?</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DoYouComeAcrossWithCredibility"
                                                                        value={pageData?.VideoRatings?.DoYouComeAcrossWithCredibility}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="lightgreen"><p>Do you appear
                                                            confident? </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DoYouAppearConfident"
                                                                        value={pageData?.VideoRatings?.DoYouAppearConfident}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="darkgreen"><p>Does your body language
                                                            convey the right message?</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DoesYourBodyLanguageConveyTheRightMessage"
                                                                        value={pageData?.VideoRatings?.DoesYourBodyLanguageConveyTheRightMessage}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="lightgreen"><p>Do you seem to believe in
                                                            what you’re saying?</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DoYouSeemToBelieveInWhatYoureSaying"
                                                                        value={pageData?.VideoRatings?.DoYouSeemToBelieveInWhatYoureSaying}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="darkgreen"><p>Do you avoid looking
                                                            directly at people? </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DoYouAvoidLookingDirectlyAtPeople"
                                                                        value={pageData?.VideoRatings?.DoYouAvoidLookingDirectlyAtPeople}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="lightgreen"><p>Did you use the
                                                            Primacy-Recency effect to structure your story? </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DidYouUseThePrimacyRecency"
                                                                        value={pageData?.VideoRatings?.DidYouUseThePrimacyRecency}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="darkgreen"><p>Did you stick to a small
                                                            number of important points?</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DidYouStickToASmallNumberOfImportantPoints"
                                                                        value={pageData?.VideoRatings?.DidYouStickToASmallNumberOfImportantPoints}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="lightgreen"><p>Is it relevant? </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="IsItRelevant"
                                                                        value={pageData?.VideoRatings?.IsItRelevant}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="darkgreen"><p>Do you use repetition or
                                                            fillers? </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DoYouUseRepetitionOrFillers"
                                                                        value={pageData?.VideoRatings?.DoYouUseRepetitionOrFillers}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="80%" align="left" valign="center"
                                                            className="lightgreen"><p>Do you use an ‘Adult’
                                                            approach? (Transactional Analysis)</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">
                                                            <p className="ilead-slect-box-yellow">
                                                                <select className="custom-dropdown"
                                                                        name="DoYouUseAnAdultApproach"
                                                                        value={pageData?.VideoRatings?.DoYouUseAnAdultApproach}
                                                                        onChange={this.props.handleChangePageData('VideoRatings')}>

                                                                    <option value="select">Select</option>
                                                                    <option value="very_ineffective">Very ineffective</option>
                                                                    <option value="ineffective">Ineffective</option>
                                                                    <option value="effective">Effective</option>
                                                                    <option value="very_effective">Very effective</option>
                                                                </select>
                                                            </p>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="border_subtitle">Step 2 – Compare your ratings</div>
                                            <p>Once you’ve rated yourself using the table above and/or asked
                                                someone else to do so, you’ll have
                                                valuable information to help develop your methods of
                                                communication.</p>
                                            <ul className="greenbullet-list">
                                                <li>Compare your own assessment with the way someone else rates
                                                    you.
                                                </li>
                                                <li>Start by identifying what you could improve.</li>
                                                <li>If you have several things which you could improve, focus on
                                                    only three at first because this will be manageable and
                                                    you’re more likely to make real progress than if you tackled
                                                    everything at once – you can work on other things, next.
                                                    Read through this tool again to find what’s relevant to what
                                                    you need most.
                                                </li>
                                                <li>If there are any discrepancies between your own and someone
                                                    else’s ratings, discuss it with them constructively by
                                                    sharing and comparing opinions to make sure you know what
                                                    you need to improve – and why.
                                                </li>
                                                <li>If someone else has rated you, ask them for any additional,
                                                    general ideas about how you
                                                    could communicate more effectively.
                                                </li>
                                                <li>Think about additional ways to learn about communication
                                                    skills – talk to your line manager
                                                    or coach about attending a workshop or other professional
                                                    training – especially if you lack
                                                    confidence, you’d be surprised how much fun it would be!
                                                </li>
                                                <li>If you have a 1 or 2 for the message/story being clear, then
                                                    use the ‘Get your story straight’
                                                    exercise on on the previous page to summarise your message
                                                    and really clarify the important points you
                                                    want to get across.
                                                </li>
                                            </ul>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page7')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}